import { CampaignDto } from '@shared/services/apiService/apiService';

import { CreateCampaignFormValue } from '../model/type';
import { normalizeCampaignAnalysisPlan } from './analysis-plan';

export type CampaignGeneralFormValues = Pick<CreateCampaignFormValue, 'id' | 'title'> &
  Partial<
    Pick<
      CreateCampaignFormValue,
      | 'reservedLimit'
      | 'retryIntervalInMinutes'
      | 'retryMaxNumber'
      | 'retriesPerDay'
      | 'callSchedule'
    >
  >;

export const getCampaignGeneralFormValues = (
  values: Partial<CreateCampaignFormValue>,
): CampaignGeneralFormValues => ({
  id: values.id ?? '',
  title: values.title ?? '',
  reservedLimit: values.reservedLimit,
  retryIntervalInMinutes: values.retryIntervalInMinutes,
  retryMaxNumber: values.retryMaxNumber,
  retriesPerDay: values.retriesPerDay,
  callSchedule: values.callSchedule,
});

export const mapCampaignDtoToFormValues = (
  campaign: CampaignDto,
): Partial<CreateCampaignFormValue> => ({
  id: campaign.id || '',
  title: campaign.title || '',
  callSchedule: campaign.callSchedule,
  retryIntervalInMinutes: campaign.retryIntervalInMinutes || 0,
  retryMaxNumber: campaign.retryMaxNumber || 0,
  retriesPerDay: campaign.retriesPerDay || 0,
  analysisPlan: normalizeCampaignAnalysisPlan(campaign.analysisPlan),
  productDetails: campaign.productDetails,
  reservedLimit: campaign.reservedLimit,
  customerListChanged: false,
});
